/* eslint-disable */
// @ts-nocheck
import * as Types from '@xing-com/crate-common-graphql-types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type GetTakenJobDetailsQueryQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;

export type GetTakenJobDetailsQueryQuery = {
  __typename?: 'Query';
  dreamJobsFetchTakenJobDetails?: Array<{
    __typename: 'OccupiedJob';
    id: string;
    urn?: string | null;
    trackingToken?: string | null;
    jobTitle?: string | null;
    companyId?: string | null;
    skillsMatchedCount?: number | null;
    skillsNotMatchedCount?: number | null;
    skillsTotal?: number | null;
    experienceMatchedScore?: number | null;
    experienceTotal?: number | null;
    takenJobLocation?: string | null;
    company?: {
      __typename: 'Company';
      companyName?: string | null;
      entityPageId?: string | null;
      entityPage?: {
        __typename?: 'EntityPage';
        id: string;
        slug: string;
        coverImage?: Array<{
          __typename?: 'ScaledImage';
          url?: string | null;
        }> | null;
      } | null;
      industry?: { __typename?: 'Industry'; localizationValue: string } | null;
      logos?: { __typename?: 'CompanyLogos'; logo256px?: string | null } | null;
      address?: { __typename?: 'CompanyAddress'; city?: string | null } | null;
      kununuData?: {
        __typename?: 'CompanyKununuData';
        companyProfileUrl?: string | null;
        ratingCount?: number | null;
        ratingAverage?: number | null;
      } | null;
      aboutUsBatched?:
        | {
            __typename: 'AboutEntity';
            aboutHeadline?: string | null;
            aboutSummary?: string | null;
          }
        | { __typename: 'EntityPageError' }
        | null;
    } | null;
    fallbackCompany?: {
      __typename?: 'FallbackCompany';
      companyName?: string | null;
      address?: { __typename?: 'FallbackAddress'; city?: string | null } | null;
    } | null;
    skillsMatched?: Array<{
      __typename?: 'DreamJobSkills';
      skill?: string | null;
    } | null> | null;
    skillsNotMatched?: Array<{
      __typename?: 'DreamJobSkills';
      skill?: string | null;
    } | null> | null;
    salary?:
      | {
          __typename: 'Salary';
          amount?: number | null;
          currency?: Types.Currency | null;
        }
      | {
          __typename: 'SalaryEstimate';
          minimum?: number | null;
          maximum?: number | null;
          median?: number | null;
          currency?: Types.Currency | null;
        }
      | {
          __typename: 'SalaryRange';
          minimum?: number | null;
          maximum?: number | null;
          currency?: Types.Currency | null;
        }
      | { __typename: 'SalaryUnauthorized' }
      | null;
    similarMembers?: Array<{
      __typename?: 'DreamJobSimilarMembers';
      user?: {
        __typename?: 'XingId';
        id: string;
        displayName: string;
        pageName: string;
        gender?: Types.Gender | null;
        profileImage?: Array<{
          __typename?: 'ProfileImage';
          url: string;
        } | null> | null;
        occupations?: Array<{
          __typename?: 'XingIdOccupation';
          subline: string;
        } | null> | null;
        location?: {
          __typename?: 'XingIdLocation';
          city?: string | null;
          displayLocation?: string | null;
        } | null;
        userFlags?: {
          __typename?: 'UserFlags';
          displayFlag?: Types.UserFlagsDisplayFlag | null;
        } | null;
      } | null;
    } | null> | null;
    preferredIndustry?: {
      __typename?: 'DreamJobIndusty';
      id?: string | null;
      value?: string | null;
    } | null;
    preferredDiscipline?: {
      __typename?: 'DreamJobDiscipline';
      id?: string | null;
      value?: string | null;
    } | null;
    vompMembers?: Array<{
      __typename?: 'DreamJobSimilarMembers';
      userId?: string | null;
    } | null> | null;
  } | null> | null;
};

export const GetTakenJobDetailsQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetTakenJobDetailsQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dreamJobsFetchTakenJobDetails' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'ids' },
                value: {
                  kind: 'ListValue',
                  values: [
                    { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'OccupiedJob' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CompanyDreamJobs' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Company' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'entityPageId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'entityPage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'coverImage' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'dimensions' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'height' },
                            value: { kind: 'IntValue', value: '300' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'reference' },
                            value: {
                              kind: 'StringValue',
                              value: 'handheld',
                              block: false,
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'width' },
                            value: { kind: 'IntValue', value: '1200' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'industry' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'localizationValue' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'logos' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'logo256px' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'kununuData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'companyProfileUrl' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'ratingCount' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'ratingAverage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'aboutUsBatched' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'AboutEntity' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'aboutHeadline' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'aboutSummary' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'JobSalary' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JobSalary' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Salary' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SalaryRange' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'minimum' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maximum' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SalaryEstimate' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'minimum' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maximum' } },
                { kind: 'Field', name: { kind: 'Name', value: 'median' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DreamJobSimilarMembers' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DreamJobSimilarMembers' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pageName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gender' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'profileImage' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'size' },
                      value: { kind: 'EnumValue', value: 'SQUARE_256' },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'occupations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'subline' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'location' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayLocation' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'userFlags' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayFlag' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OccupiedJob' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OccupiedJob' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'urn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'trackingToken' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jobTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CompanyDreamJobs' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fallbackCompany' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'address' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'takenJobLocation' },
            name: { kind: 'Name', value: 'location' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'skillsMatchedCount' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'skillsMatched' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'skill' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'skillsNotMatchedCount' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'skillsNotMatched' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'skill' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'skillsTotal' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'experienceMatchedScore' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'experienceTotal' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'salary' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'JobSalary' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'similarMembers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'DreamJobSimilarMembers' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'preferredIndustry' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'preferredDiscipline' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vompMembers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetTakenJobDetailsQueryQuery,
  GetTakenJobDetailsQueryQueryVariables
>;
